document.addEventListener('DOMContentLoaded', function() {
  // Funktion til at opdatere lagerstatus
  function updateInventoryNote(variant) {
    const inventoryNote = document.querySelector('.inventory-note');
    if (!inventoryNote) return;

    const quantity = parseInt(inventoryNote.getAttribute('data-inventory-quantity'), 10);
    const statusDiv = inventoryNote.querySelector('.inventory-status');
    const icon = statusDiv.querySelector('.icon--pulsing');
    const textSpan = statusDiv.querySelector('span:nth-child(2)');

    if (variant.available) {
      if (variant.inventory_quantity <= 1) {
        statusDiv.classList.remove('inventory-high', 'inventory-sold-out');
        statusDiv.classList.add('inventory-low');
        textSpan.textContent = '• På lager (Begrænset beholdning)';
      } else {
        statusDiv.classList.remove('inventory-low', 'inventory-sold-out');
        statusDiv.classList.add('inventory-high');
        textSpan.textContent = '• På lager: 1-2 dages levering';
      }
    } else {
      statusDiv.classList.remove('inventory-low', 'inventory-high');
      statusDiv.classList.add('inventory-sold-out');
      textSpan.textContent = '• Udsolgt';
    }
  }

  // Lyt til variantændringer
  const productForm = document.querySelector('form.product-form');
  if (productForm) {
    productForm.addEventListener('change', function(event) {
      const selectedVariantId = event.target.value;
      fetch(`/products/${window.location.pathname.split('/').pop()}.js`)
        .then(response => response.json())
        .then(product => {
          const variant = product.variants.find(v => v.id.toString() === selectedVariantId);
          if (variant) {
            updateInventoryNote(variant);
          }
        })
        .catch(error => console.error('Error fetching product data:', error));
    });
  }
});
